import { UserApiUserUpdateEmailRequest } from '../../openapi/api'
import appApiClient from './appApiClient'
import useBaseMutation from './useBaseMutation'

export const useUserUpdateEmailMutation = () =>
  useBaseMutation({
    mutationFn: (req: UserApiUserUpdateEmailRequest, config) =>
      appApiClient.userApi.userUpdateEmail(req, config),
  })
